export const convertToMultiLine = text => text.replace(new RegExp('/$'), '').replace(new RegExp('/', 'g'), '>/').split('/');
export const convertToSingleLine = text => text.replace(new RegExp('/', 'g'), '>').replace(new RegExp('>$'), '');
export const minRoundCoverage = 0.0001;
